import 'regenerator-runtime/runtime';
import Graph from 'graphology';
import gexf from 'graphology-gexf/browser';

import * as sigma from '/vendor/sigma.min';

let urlLookup;
let newsletterLookup;
let selectedNode = false;

const hide = () => {
  const spinnerDiv = document.getElementById('spinner');
  spinnerDiv.style['background-color'] = 'rgba(0,0,0,0)';

  let overlayDiv = document.getElementById('overlay');
  let holdDiv = document.getElementById('hold');

  const remove = () => {
    overlayDiv.remove();
    overlayDiv = null;
  };

  overlayDiv.style.animation = 'fade-out 2s ease-in';
  overlayDiv.style.opacity = '0';
  overlayDiv.addEventListener('animationend', remove);
  overlayDiv.addEventListener('webkitAnimationEnd', remove);
  holdDiv.remove();
};

let highlightedNodes = new Set();
let highlightedEdges = new Set();

const nodeReducer = (node, data) => {
  if (highlightedNodes.size === 0 && highlightedEdges.size === 0) {
    return {
      ...data,
    };
  }
  if (highlightedNodes.has(node)) {
    return {
      ...data,
      size: data.size * 1.5,
      color: 'rgba(255,255,255)',
      originalSize: data.size,
      zIndex: 1,
    };
  } else {
    return {
      ...data,
      size: data?.originalSize || data.size,
    };
  }
};

const edgeReducer = (edge, data) => {
  if (highlightedNodes.size === 0 && highlightedEdges.size === 0) {
    return {
      ...data,
    };
  }
  if (highlightedEdges.has(edge)) {
    return {
      ...data,
      zIndex: 1,
      size: data.size * 1.1,
    };
  } else {
    return {
      ...data,
    };
  }
};

const getJson = async (filename) => {
  return fetch(`${window.location.href}/${filename}`).then((response) =>
    response.json()
  );
};

window.onload = async () => {
  const data = await getJson(`graph.json`);
  urlLookup = await getJson(`linkMetadata.json`);
  newsletterLookup = await getJson(`newsletterMetadata.json`);
  const graph = new Graph();
  graph.import(data);

  graph.forEachNode((key, attributes) => {
    let { type, newsletter, url = '', weight } = attributes;
    const nodeAttributes =
      type === 'newsletter'
        ? {
            label: newsletter,
            color: '#09FBD3',
            size: Math.sqrt(Math.sqrt(weight)),
            metadata: newsletterLookup[newsletter],
          }
        : {
            label: url,
            color: '#FE53BB',
            size: Math.sqrt(weight),
            metadata: { url, ...urlLookup[url] },
          };
    graph.mergeNodeAttributes(key, nodeAttributes);
  });

  graph.forEachEdge((key, attributes) => {
    graph.mergeEdgeAttributes(key, {
      color: 'rgba(10,10,10,0.1)',
      size: 0.2,
    });
  });

  const container = document.getElementById('chart');

  const renderer = new sigma.WebGLRenderer(graph, container, {
    nodeReducer,
    edgeReducer,
    defaultLabelColor: 'white',
    labelHoverColor: 'node',
    defaultNodeHoverColor: 'node',
    labelBackgroundColor: '#000',
    labelShadowColor: 'rgba(0,0,0,0)',
  });

  hide();

  const resetSidebar = () => {
    document.getElementById('title').innerHTML = '';
    document.getElementById('description').innerText = '';
    document.getElementById('image').src = '';
  };

  const setSidebar = (node) => {
    if (!node) {
      resetSidebar();
    } else {
      let {
        metadata: { url, title, description, image },
      } = graph.getNodeAttributes(node);

      document.getElementById(
        'title'
      ).innerHTML = `<a href="${url}" target="_blank" rel="noopener noreferrer">${
        title || url
      } 🔗</a>`;
      document.getElementById('description').innerText = description || '';
      document.getElementById('image').src = image || '';
    }
  };

  const highlightNeighbours = (node) => {
    if (!node) {
      highlightedEdges = new Set();
      highlightedNodes = new Set();
    } else {
      const neighbors = graph.neighbors(node);

      highlightedNodes = new Set(neighbors);
      highlightedEdges = new Set(graph.edges(node));

      highlightedNodes.add(node);
    }
    renderer.refresh();
  };

  document
    .getElementById('chart')
    .addEventListener('dblclick', function (event) {
      if (selectedNode) {
        let {
          metadata: { url },
        } = graph.getNodeAttributes(selectedNode);

        if (url) {
          window.open(url, '_blank');
        }
      }
    });

  renderer.on('clickNode', ({ node }) => {
    selectedNode = node;
    setSidebar(node);
  });

  renderer.on('clickStage', () => {
    selectedNode = false;
    setSidebar();
  });

  renderer.on('enterNode', ({ node }) => {
    if (!selectedNode) {
      setSidebar(node);
      // highlightNeighbours(node);
    }
  });

  renderer.on('exitNode', ({}) => {});

  window.renderer = renderer;
  window.camera = renderer.getCamera();
};
